import React from "react";
import Icons from "@hs/icons";
import MainSearchScope from "components/MainSearchScope";
import Divider from "components/Divider";
import { getLocalizedText } from "data/utils";
import styles from "./Mask.module.css";

type Props = {
    /** initial search scope */
    searchScope: SearchScopeEnum,
    /** initial search scope itemUri */
    itemUri: string,
    /** callback when user changes search scope
     * @param {SearchScopeEnum} searchScope new search scope
     * @param {string} itemUri new scoped itemUri
     */
    onScopeChange: (searchScope: SearchScopeEnum, scopeItemUri: string) => void,
    /** default expanded state */
    defaultExpanded: boolean,
};
const SearchScope = ({
    searchScope,
    itemUri,
    onScopeChange,
    defaultExpanded,
}: Props) => (
    <Divider
        name="showSearchScope"
        hideHR
        className={styles.header}
        defaultExpanded={defaultExpanded}
        header={
            <>
                {getLocalizedText("$search:mask.scope")}
                <Icons.Library
                    name="fa-regular fa-circle-dot"
                    fixedWidth
                    className={styles.icon}
                />
            </>
        }
    >
        <MainSearchScope
            className={styles.scope}
            searchScope={searchScope}
            itemUri={itemUri}
            onChange={onScopeChange}
        />
    </Divider>
);

SearchScope.displayName = "SearchMask.SearchScope";
export default SearchScope;
